import {IconSize} from '@Components/icon-v2/icon.types';
import {AiPromptBoxSize} from '@Components/ai-prompt-box/ai-prompt-box.types';
import {triggerPanelClose} from '@Components/panel/panel-reducer';
import actionButtonStyles from '../../ai-prompt-box-action-button.module.scss';

export interface FooterSelectorIconTriggerSizing {
  triggerClass: string;
  iconSize: IconSize;
}

const smallIconTriggerSizing: FooterSelectorIconTriggerSizing = {
  triggerClass: actionButtonStyles.actionButtonSmall,
  iconSize: IconSize.SIZE_ICON_16,
};

const iconTriggerSizingMap: Record<AiPromptBoxSize, FooterSelectorIconTriggerSizing> = {
  [AiPromptBoxSize.SMALL]: smallIconTriggerSizing,
  [AiPromptBoxSize.SMALL_EXTENDED]: smallIconTriggerSizing,
  [AiPromptBoxSize.SINGLE_LINE]: {...smallIconTriggerSizing, triggerClass: actionButtonStyles.actionButtonSingleLine},
  [AiPromptBoxSize.MEDIUM]: {
    triggerClass: actionButtonStyles.actionButtonMedium,
    iconSize: IconSize.SIZE_ICON_20,
  },
};

export const getFooterSelectorIconTriggerSizing = (promptBoxSize: AiPromptBoxSize): FooterSelectorIconTriggerSizing => {
  return iconTriggerSizingMap[promptBoxSize];
};

// Only the modal registers this id, so an absent entry means the sheet is closed and triggerPanelClose would throw.
// The selector must never register it, or the trigger would outlive the sheet and keep it from closing.
export const closeFooterSelectorSmallScreenModal = (panelId: string): void => {
  const isSmallScreenModalOpen = window.PMW.redux.store.getState().panels.panelHashmap[panelId] !== undefined;
  if (!isSmallScreenModalOpen) {
    return;
  }

  window.PMW.redux.store.dispatch(triggerPanelClose(panelId));
};
